import { render } from "./configChoose.vue?vue&type=template&id=251162ac&scoped=true"
import script from "./configChoose.vue?vue&type=script&lang=js"
export * from "./configChoose.vue?vue&type=script&lang=js"

import "./configChoose.vue?vue&type=style&index=0&id=251162ac&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251162ac"]])

export default __exports__